import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles ,useTheme} from "@material-ui/core/styles";
import {
  StyledCircularProgress,
  StyledCircularProgressBlack,
} from "../Commons/styledTabs";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
  },
  progress: {
    margin: "auto",
  },
}));

export default ({ isLoading = false, isFlight = false }) => {
  const classes = useStyles();
  const theme = useTheme();
  if (!isLoading) return null;

  return (
    <Container className={classes.container}>
      {isFlight ? (
        <StyledCircularProgressBlack className={classes.progress} style={{ color: theme?.agentTheme?.primary?.main }}/>
      ) : (
        <StyledCircularProgress className={classes.progress} style={{ color: theme?.agentTheme?.primary?.main }}/>
      )}
    </Container>
  );
};
